module.exports = __webpack_public_path__ + "media/typy/dostawcze-926dfef4.png";